module.exports = __webpack_public_path__ + "static/img/banner-5.9c04e2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner-5.jpg
// module id = jGKZ
// module chunks = 1